import React from 'react';
import './Grid.css';
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import MaterialTable from '@material-table/core';
import PropTypes from 'prop-types';

// Create theme outside of component to prevent recreation on each render
const defaultTheme = createTheme();

const customTheme = createTheme({
  ...defaultTheme,
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          paddingTop: 4,
          paddingBottom: 4,
          backgroundColor: 'transparent',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          width: 'inherit',
        },
      },
    },
  },
});

function Grid({
  className,
  keyGrid,
  columns,
  data,
  actions,
  options,
  localization,
  isLoading,
  detailPanel,
  components
}) {
  const defaultOptions = {
    pageSize: 15,
    selection: false,
    filtering: false,
    search: false,
    showTitle: false,
    toolbar: false,
    pageSizeOptions: [10],
    emptyRowsWhenPaging: false,
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={customTheme}>
        <MaterialTable
          className={className}
          key={keyGrid}
          columns={columns}
          data={data}
          actions={actions}
          localization={localization}
          isLoading={isLoading}
          options={{ ...defaultOptions, ...options }}
          detailPanel={detailPanel}
          components={components}
        />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}


Grid.propTypes = {
  options: PropTypes.object.isRequired,
  className: PropTypes.string,
  keyGrid: PropTypes.number.isRequired,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  actions: PropTypes.array,
  localization: PropTypes.object,
  isLoading: PropTypes.bool,
  detailPanel: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.array
  ]),
  components: PropTypes.object
};

Grid.defaultProps = {
  className: '',
  localization: {},
  actions: [],
  isLoading: false,
  detailPanel: null,
  components: {}
};

export default Grid;
